'use client';
import { useState } from 'react';

import getAPI from '@graphql/getAPI';
import { Link } from '@heroui/link';
import { FormFieldHelpers, ZodForm } from '@rachelallyson/hero-hook-form';
import { capture, EventType } from '@Soultrics/_utils/events';
import { z } from 'zod';

const forgotSchema = z.object({
  email: z
    .string()
    .email('Must be a valid email address')
    .min(1, 'Email is required'),
});

type ForgotFormData = z.infer<typeof forgotSchema>;

function Forgot() {
  const [success, setSuccess] = useState(false);

  return (
    <>
      <div className="flex items-center">
        <div className="grid p-4 gap-4 items-center w-full">
          {!success && (
            <>
              <ZodForm<ForgotFormData>
                config={{
                  defaultValues: { email: '' },
                  fields: [
                    FormFieldHelpers.content('Password Recovery', undefined),
                    FormFieldHelpers.input('email', 'Email', 'email'),
                  ],
                  schema: forgotSchema,
                }}
                errorDisplay="inline"
                submitButtonText="Reset Password"
                onSubmit={async (data: { email: string }) => {
                  const client = getAPI();

                  await client.forgotPassword(data);
                  capture(EventType.EMAIL_FORGOT_PASSWORD);
                }}
                onSuccess={() => setSuccess(true)}
              />
              <div className="grid grid-cols-2">
                <p>
                  Already Have an Account?&nbsp;
                  <Link href="/login">Log In</Link>
                </p>
              </div>
            </>
          )}
          {success && (
            <p className="mt-4 text-center">
              <strong>Success!</strong>
              {` A recovery link has been sent to your
              email. Please click on the link to set a new password.`}
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default Forgot;
